import { useState } from 'react'
import router from 'next/router'

import { withUserContext } from 'context'
import { Icon } from 'components/common'


const Favorite = ({ debateId, ...props }) => {

    const [isFavorite, setIsFavorite] = useState(props?.user?.favorites?.includes(debateId))

    const toggleFavorite = () => {
        if (props.isLoggedIn) {
            props.toggleFavorite(debateId).then(() => setIsFavorite(!isFavorite))
        } else {
            let asPath = router.asPath
            let path = router.query.s ? `${asPath}&c=login` : `${asPath}?c=login`
            router.push(path)
        }
    }

    return (
        <Icon className={`darkGrey cursorPointer op-star ${isFavorite ? 'active' : ''}`} onClick={toggleFavorite}>
            <span className='path1'></span>
            <span className='path2'></span>
        </Icon>
    )
}

export default withUserContext(Favorite, ['toggleFavorite', 'user', 'isLoggedIn'])